// Place your custom JavaScript here.


$(document).ready(function() {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {

		// skip if it has this class
		if($(this).hasClass('no-automatic-responsiveness'))
			return;
		if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	if (!$('.top-bar-overlay li').hasClass('hide animated')) {
		$('.top-bar-overlay li').each(function() {
			let item = $(this);
			item.addClass('hide animated');
		});
	}

	$('.top-bar-overlay .overlay > li').each(function(index) {
		let item = $(this);
		item.addClass(`delay-${index}`);
	});
	$('.top-bar-overlay .submenu').each(function() {
		$(this).children().each(function(index) {
			$(this).addClass(`delay-${index}`);
		});
	});

	$("[data-toggle='top-bar-overlay']").click(() => {
		if ($('.top-bar-overlay').hasClass('hidden')) {
			$('.top-bar-overlay').removeClass('hidden');
			$('.overlay-logo').addClass('fadeInUp');
			$('.trail').addClass('zoomIn');
			$('.overlay-portfolio').addClass('fadeInUp');
			$('.top-bar-overlay li').each(function(index) {
				let item = $(this);
				item.removeClass('hide');
				item.addClass('fadeInUp');
			});
		} else {
			$('.top-bar-overlay').addClass('hidden');
			$('.overlay-logo').removeClass('fadeInUp');
			$('.trail').removeClass('zoomIn');
			$('.overlay-portfolio').removeClass('fadeInUp');
			$('.top-bar-overlay li').each(function() {
				let item = $(this);
				item.addClass('hide');
				item.removeClass('fadeInUp');
			});
		}
		$('body').toggleClass('no-scroll');
	});
});

	var searchWidth = 170;
    var searchHeight = 21;

    if (window.innerWidth < 700) {
        // alert("mobile");
        // alert("sl" + window.innerWidth);
        searchWidth = 120;
        searchHeight = 10;
    }
    else {
        // alert("not mobile");
        // alert("sl" + window.innerWidth);
        searchWidth = 170;
        searchHeight = 10;
    }

	var clicked1 = false;
   $(".top-search .search-form .input-group .input-group-field").width(0);
   $(".top-search .search-form .input-group .input-group-field").hide();

   $(".top-search .search-form .input-group .input-group-label").on('click', function () {
       if (clicked1) {
           clicked1 = false;
           $(".top-search .search-form .input-group .input-group-field").width(0);
           $(".top-search .search-form .input-group .input-group-field").hide();

       } else {
            clicked1 = true;
            $(".top-search .search-form .input-group .input-group-field").width(searchWidth).height(searchHeight);
           $(".top-search .search-form .input-group .input-group-field").show();
       }
   });

   

($ => {
	/*
	 *  new_map
	 *
	 *  This function will render a Google Map onto the selected jQuery element
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$el (jQuery element)
	 *  @return	n/a
	 */

	function new_map($el) {
		// var markers = new google.maps.Marker({
		// 	position: latlng,
		// 	map:      map,
		// 	title:    'DSRU',
		// 	icon:     'http://localhost/ventilex/wp-content/uploads/ventilexmarker.png' 
		// });
		// var
		const $markers = $el.find('.marker');
		

		// vars
		// const args = {
		// 	zoom: 8,
		// 	center: new google.maps.LatLng(0, 0),
		// 	mapTypeId: google.maps.MapTypeId.ROADMAP,
			
		// };
		 // Create gerenic map.
		 var args = {
			zoom        : $el.data('zoom') || 8,
			mapTypeId   : google.maps.MapTypeId.ROADMAP
		};

		// create map
		var map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function() {
			add_marker($(this), map);
		});

		// center map
		center_map(map);

		// return
		return map;
	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker($marker, map) {
		// var
		const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		const marker = new google.maps.Marker({
			position: latlng,
			map : map,
			icon:   'https://www.ventilex.com/wp-content/uploads/ventilexmarker1-removebg-preview.png',
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			const infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', () => {
				infowindow.open(map, marker);
			});
		}
	}

	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map(map) {
		// vars
		const bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, (i, marker) => {
			const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			// map.setZoom(13);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	// window.goToAnchorLink = function(x){

	// 	var loc = $('#test1');
	// 	var stickyHeight = window.innerHeight;
	// 	Foundation.SmoothScroll.scrollToLoc(loc, {
	// 		threshold: 0,
	// 		offset: 2000

	// 	});
	// 	console.log(stickyHeight);
	// }

	// function goToAnchorLink(){
	// 	var h = window.innerHeight;
	// 	window.scrollBy(0, h/2.5),3000;

	//   console.log( window.scrollBy(0, h/3));
	//   }


	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	let map = null;

	$(document).ready(() => {
		$('.acf-map').each(function() {
			// create map
			map = new_map($(this));
		});
	});
})(jQuery);
